import { createFileRoute } from '@tanstack/react-router'

import EditPetaniPage from '@/components/pages/backoffice/_klb-petani/_petani/_$petaniId/edit/containers/EditPetaniPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/petani/$petaniId/edit'
)({
  component: EditPetaniPage
})
